exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router{\r\n    /* padding-left: 30px;\r\n    padding-right: 30px; */\r\n    background-image: url(/assets/back2.jpg);\r\n        /* Create the parallax scrolling effect */\r\n        background-attachment: fixed;\r\n        background-position: center;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        padding-top:100px;\r\n    \r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main